// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Ticket$ReactHooksTemplate = require("./ticket.res.js");
var TicketView$ReactHooksTemplate = require("./TicketView.res.js");
var DomainModel$ReactHooksTemplate = require("../settings/domainModel.res.js");

function fetchTicket(id) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/tickets/" + id, (function (param) {
                return Json_decode.field("ticket", Ticket$ReactHooksTemplate.decode, param);
              }));
}

function TicketStandAloneView(props) {
  var id = props.id;
  var match = React.useState(function (param) {
        
      });
  var setTicket = match[1];
  var ticket = match[0];
  var match$1 = React.useState(function (param) {
        return {
                agents: /* [] */0,
                assignee: undefined
              };
      });
  var setState = match$1[1];
  var state = match$1[0];
  var fetchTicketWorkers = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/recovery_agents", (function (param) {
                  return Json_decode.field("recovery_agents", (function (param) {
                                return Json_decode.list(Ticket$ReactHooksTemplate.Assignee.decode, param);
                              }), param);
                }));
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (x) {
                  return Promise.resolve((Curry._1(setTicket, (function (param) {
                                      return x;
                                    })), Js_promise.then_((function (agents) {
                                      return Promise.resolve(Curry._1(setState, (function (param) {
                                                        return {
                                                                agents: agents,
                                                                assignee: state.assignee
                                                              };
                                                      })));
                                    }), fetchTicketWorkers()), undefined));
                }), fetchTicket(id));
        }), []);
  var updateTickets = function (ticketId, status) {
    if (ticket === undefined) {
      return ;
    }
    if (Ticket$ReactHooksTemplate.id(ticket) !== ticketId) {
      return Curry._1(setTicket, (function (param) {
                    return ticket;
                  }));
    }
    var tic = Ticket$ReactHooksTemplate.updateTicketStatus(status, ticket);
    Curry._1(setTicket, (function (param) {
            return tic;
          }));
  };
  var assignTicket = function (ticketId) {
    var assignee = state.assignee;
    if (assignee === undefined) {
      return ;
    }
    var assigneeId = Ticket$ReactHooksTemplate.Assignee.id(assignee);
    var params = {};
    params["assignee_id"] = assigneeId;
    if (ticket === undefined) {
      return ;
    }
    if (Ticket$ReactHooksTemplate.id(ticket) !== ticketId) {
      return Curry._1(setTicket, (function (param) {
                    return ticket;
                  }));
    }
    var ticketArray = Belt_List.fromArray([ticket]);
    var ticketIds = Belt_List.map(ticketArray, Ticket$ReactHooksTemplate.id);
    params["ids"] = Json_encode.list((function (prim) {
            return prim;
          }), ticketIds);
    var ticket$1 = {};
    ticket$1["ticket"] = params;
    Js_promise.then_((function (param) {
            var tic = Ticket$ReactHooksTemplate.updateAssignee(state.assignee, ticket);
            return Promise.resolve(Curry._1(setTicket, (function (param) {
                              return tic;
                            })));
          }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/tickets/assign", ticket$1));
  };
  var handleAssigneeSelection = function ($$event) {
    var emailText = Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.create, Utils$ReactHooksTemplate.formTargetValue($$event));
    if (Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.isEmpty, emailText)) {
      return Curry._1(setState, (function (param) {
                    return {
                            agents: state.agents,
                            assignee: undefined
                          };
                  }));
    }
    var selected = List.find((function (assignee) {
            return Caml_obj.equal(Ticket$ReactHooksTemplate.Assignee.email(assignee), emailText);
          }), state.agents);
    Curry._1(setState, (function (param) {
            return {
                    agents: state.agents,
                    assignee: selected
                  };
          }));
  };
  return JsxRuntime.jsx("div", {
              children: ticket !== undefined ? JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("a", {
                              children: JsxRuntime.jsx("img", {
                                    className: "custom-back mb-4",
                                    src: Image$ReactHooksTemplate.backArrow
                                  }),
                              href: "/tickets/manage/all"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(TicketView$ReactHooksTemplate.make, {
                                    ticket: ticket,
                                    updateTickets: updateTickets,
                                    handleAssigneeSelection: handleAssigneeSelection,
                                    assignTicket: assignTicket,
                                    agents: state.agents
                                  }),
                              className: "w-full border border-gray-300 rounded-lg"
                            })
                      ],
                      className: "p-30-px"
                    }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
              className: "flex flex-col 1/2"
            });
}

var make = TicketStandAloneView;

exports.fetchTicket = fetchTicket;
exports.make = make;
/* react Not a pure module */
